//src/components/AdminSidebar.js
import { NavLink } from "react-router-dom";

const base =
  "flex items-center gap-3 px-4 py-2 rounded-xl text-sm transition";
const active = "bg-purple-600 text-white";
const inactive = "text-slate-300 hover:bg-white/10";

export default function AdminSidebar() {
  const cls = ({ isActive }) =>
    `${base} ${isActive ? active : inactive}`;

  return (
    <aside className="w-64 bg-black/40 border-r border-white/10">
     <div className="flex items-center gap-3 mb-6 px-2">
  <img src="/logo.png" className="w-9 h-9 rounded-xl" />
  <div>
    <div className="font-semibold">SMSOrbit</div>
    <div className="text-xs text-slate-400">Admin Panel</div>
  </div>
</div>

      <nav className="p-4 space-y-1">
        <NavLink to="/admin/dashboard" className={cls}>Dashboard</NavLink>
        <NavLink to="/admin/orders" className={cls}>Orders</NavLink>
        <NavLink to="/admin/users" className={cls}>Users</NavLink>
        <NavLink to="/admin/services" className={cls}>Services</NavLink>
        <NavLink to="/admin/providers" className={cls}>Providers</NavLink>
        <NavLink to="/admin/internal-orders" className={cls}>Internal Orders</NavLink>
        <NavLink to="/admin/mass-orders" className={cls}>Mass Orders</NavLink>
        <NavLink to="/admin/wallet" className={cls}>Wallet Requests</NavLink>
        <NavLink to="/admin/tickets" className={cls}>Tickets</NavLink>
        <NavLink to="/admin/settings" className={cls}>Settings</NavLink>
      </nav>
    </aside>
  );
}
